import React from 'react';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './Hosts.scss';

const Hosts = () => (
  <div className="">
    <LazyLoadTransition>
      <h1 className="section-title">HOSTED BY</h1>
      <div className="columns is-multiline is-centered">
        <div className="column is-4 is-12-touch is-12-mobile">
          <a href="https://www.instagram.com/marnickvandebroek/" rel="noreferrer" target="_blank">
            <div className="host-card-content">
              <img alt="Marnick Vandebroek" src="imgs/hosts/marnickvandebroek.jpg" />
              <p>Marnick Vandebroek</p>
            </div>
          </a>
        </div>
        <div className="column is-4 is-12-touch is-12-mobile">
          <a href="https://www.instagram.com/janogordulic/" rel="noreferrer" target="_blank">
            <div className="host-card-content">
              <img alt="Ján Gordulič" src="imgs/hosts/jangordulic.jpg" />
              <p>Ján Gordulič</p>
            </div>
          </a>
        </div>
      </div>
    </LazyLoadTransition>
  </div>
);

export default Hosts;
